import React, { useState, useEffect, useContext } from "react";
import AdminLayout from "../../components/layout/AdminLayout";
import { Helmet } from "react-helmet-async";
import "./EditCourseOfferingPage.css";
import { useNavigate, useParams } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";
import axios from "axios";
import ErrorLogger from "../../components/ErrorLogger";
import setAuthToken from "../../functions/auth_header";
import { getAppUrl } from "../../functions/getEnv";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";

const ITEMS_PER_PAGE = 13;

const EditFinalCourse = () => {
  const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);
  const navigate = useNavigate();
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const { charter, charter_id, name, courseid, permalink, id } = useParams();
  const {
    CourseCatalog,
    fetchCourseCatalogOptions,
    CourseOptionCatalogID,
    getCourseOptionCatalogID,
  } = adminRegistrationContext;
  const [gradeLevels, setGradeLevels] = useState([]);

  const includeNCAA = [
    ...new Set(
      CourseCatalog.filter((item) => item.LeloRegistrationProfile === courseid) // Filter by permalink
        .map((item) => item.highSchoolDetails?.includeNCAA)
        .filter((value) => value)
    ),
  ];
  const defaultIncludeNCAA = includeNCAA[0];
  const [highSchoolDetails, setHighSchoolDetails] = useState({
    includeNCAA: defaultIncludeNCAA,
    totalCourses: "",
    courseType: "High School",
    courseYear: "",
    catalogTerm: "",
    courses: [],
  });
  const [middleSchoolDetails, setMiddleSchoolDetails] = useState({
    totalCourses: "",
    courseType: "Middle School",
    courseYear: "",
    catalogTerm: "",
    courses: [],
  });
  const [elementarySchoolDetails, setElementarySchoolDetails] = useState({
    totalCourses: "",
    courseType: "Elementary School",
    courseYear: "",
    catalogTerm: "",
    courses: [],
  });

  const [selectedCourses, setSelectedCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [unselectedCourses, setUnselectedCourses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalUrl, setModalUrl] = useState("");

  const siteIdString = Object.values(id).join("");

  const [leftItems, setLeftItems] = useState([
    ...highSchoolDetails.courses,
    ...middleSchoolDetails.courses,
    ...elementarySchoolDetails.courses,
  ]);
  const [state, setState] = useState({
    rightItems: [],
    rightItems1: [],
    rightItems2: [],
    leftSearch: "",
    leftSearch1: "",
    leftSearch2: "",
    rightSearch: "",
    rightSearch1: "",
    rightSearch2: "",
    leftPage: 1,
    leftPage1: 1,
    leftPage2: 1,
    rightPage: 1,
    rightPage1: 1,
    rightPage2: 1,
  });

  const moveItems = (
    sourceItems,
    targetItems,
    setSourceItems,
    setTargetItems,
    isRemovingCourses = false
  ) => {
    // Get all selected courses that are in the source items
    const itemsToMove = selectedCourses.filter((course) =>
      sourceItems.some((item) => item.course_name === course.course_name)
    );

    // Remove moved items from sourceItems
    const updatedSourceItems = sourceItems.filter(
      (item) =>
        !itemsToMove.some((course) => course.course_name === item.course_name)
    );
    setSourceItems(updatedSourceItems);

    // Add moved items to targetItems (ensuring uniqueness)
    const updatedTargetItems = [
      ...targetItems.filter(
        (item) =>
          !itemsToMove.some((course) => course.course_name === item.course_name)
      ),
      ...itemsToMove,
    ];
    setTargetItems(updatedTargetItems);

    // Handle deletion logic
    if (isRemovingCourses) {
      // When moving left (<<), all moved courses should be marked for deletion
      setUnselectedCourses((prevUnselected) => [
        ...prevUnselected,
        ...itemsToMove,
      ]);
    }

    // Clear selectedCourses after moving
    setSelectedCourses([]);
  };

  const paginate = (items, page) => {
    const startIndex = (page - 1) * ITEMS_PER_PAGE;
    return items.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  };

  const renderPagination = (items, page, setPage) => {
    const totalPages = Math.ceil(items.length / ITEMS_PER_PAGE);

    return (
      <div className="pagination">
        <button
          onClick={() => setPage(page > 1 ? page - 1 : page)}
          disabled={page === 1}
          className="prev-button"
        >
          Previous
        </button>

        <span style={{ margin: "0 2px" }}>
          {page} of {totalPages}
        </span>

        <button
          onClick={() => setPage(page < totalPages ? page + 1 : page)}
          disabled={page === totalPages || totalPages === 0}
          className="next-button"
        >
          Next
        </button>
        {/* "Select All Courses" Button */}
        <button
          onClick={() => handleSelectAll(items)}
          disabled={items.length === 0}
          className="select-all-button"
          style={{
            marginLeft: "10px",
            padding: "12px 24px",
            width: "110px",
          }}
        >
          Select All
        </button>
      </div>
    );
  };

  const handleLeftSearchChange = (e) => {
    //high school
    setState({
      ...state,
      leftSearch: e.target.value,
      leftPage: 1,
    });
  };

  const handleLeftSearchChange1 = (e) => {
    //middle school
    setState({
      ...state,
      leftSearch1: e.target.value,
      leftPage1: 1, // Reset to first page on search
    });
  };
  const handleLeftSearchChange2 = (e) => {
    //elementary school
    setState({
      ...state,
      leftSearch2: e.target.value,
      leftPage2: 1, // Reset to first page on search
    });
  };

  const handleRightSearchChange = (e) => {
    setState({
      ...state,
      rightSearch: e.target.value,
      rightPage: 1, // Reset to first page on search
    });
  };

  const handleRightSearchChange1 = (e) => {
    setState({
      ...state,
      rightSearch1: e.target.value,
      rightPage1: 1, // Reset to first page on search
    });
  };
  const handleRightSearchChange2 = (e) => {
    setState({
      ...state,
      rightSearch2: e.target.value,
      rightPage2: 1, // Reset to first page on search
    });
  };

  const filterItems = (items, searchTerm) => {
    return items.filter((item) =>
      item.course_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  useEffect(() => {
    if (CourseCatalog?.length > 0 && courseid) {
      const filteredCatalog = CourseCatalog.filter(
        (item) => item.LeloRegistrationProfile === courseid
      );

      // Fetch high school details
      const highSchool = filteredCatalog
        .map((item) => item.highSchoolDetails)
        .find(Boolean); // Find the first non-null value

      // Fetch middle school details
      const middleSchool = filteredCatalog
        .map((item) => item.middleSchoolDetails)
        .find(Boolean);

      // Fetch elementary school details
      const elementarySchool = filteredCatalog
        .map((item) => item.elementarySchoolDetails)
        .find(Boolean);

      // Update states
      setHighSchoolDetails((prev) => ({
        ...prev,
        includeNCAA: highSchool?.includeNCAA || "No",
        totalCourses: highSchool?.totalCourses || "",
      }));

      setMiddleSchoolDetails((prev) => ({
        ...prev,
        totalCourses: middleSchool?.totalCourses || "",
      }));

      setElementarySchoolDetails((prev) => ({
        ...prev,
        totalCourses: elementarySchool?.totalCourses || "",
      }));
    }
  }, [CourseCatalog, courseid]);

  useEffect(() => {
    if (CourseCatalog?.length > 0 && permalink) {
      const includeNCAA = [
        ...new Set(
          CourseCatalog.filter(
            (item) => item.LeloRegistrationProfile === courseid
          )
            .map((item) => item.highSchoolDetails?.includeNCAA)
            .filter((value) => value) // Exclude undefined or null
        ),
      ];

      const defaultIncludeNCAA = includeNCAA[0]; // Default to "No" if not found

      setHighSchoolDetails((prev) => ({
        ...prev,
        includeNCAA: defaultIncludeNCAA,
      }));
    }
  }, [CourseCatalog, courseid]);

  useEffect(() => {
    fetchCourseCatalogOptions(id);
    getCourseOptionCatalogID(charter_id);
  }, [defaultIncludeNCAA]);

  useEffect(() => {
    if (CourseOptionCatalogID.length > 0) {
      const catalogItem = CourseOptionCatalogID.find(
        (item) =>
          item.course_type === highSchoolDetails.courseType &&
          middleSchoolDetails.courseType &&
          elementarySchoolDetails.courseType
      );
      if (catalogItem) {
        setHighSchoolDetails((prevDetails) => ({
          ...prevDetails,
          courseYear: catalogItem.school_year,
          catalogTerm: catalogItem.catalog_term,
          courseType: catalogItem.course_type,
        }));
      }
    }
  }, [
    CourseOptionCatalogID,
    highSchoolDetails.courseType,
    middleSchoolDetails.courseType,
    elementarySchoolDetails.courseType,
  ]);
  useEffect(() => {
    const updateDetails = (details, setDetails) => {
      if (CourseOptionCatalogID.length > 0) {
        const catalogItem = CourseCatalog.find(
          (item) =>
            item.LeloRegistrationProfile === courseid &&
            item.course_type === details.courseType
        );
        if (catalogItem) {
          setDetails((prevDetails) => ({
            ...prevDetails,
            courseYear: catalogItem.school_year,
            catalogTerm: catalogItem.catalog_term,
            courseType: catalogItem.course_type,
          }));
        }
      }
    };

    updateDetails(highSchoolDetails, setHighSchoolDetails);
    updateDetails(middleSchoolDetails, setMiddleSchoolDetails);
    updateDetails(elementarySchoolDetails, setElementarySchoolDetails);
  }, [
    CourseOptionCatalogID,
    highSchoolDetails.courseType,
    middleSchoolDetails.courseType,
    elementarySchoolDetails.courseType,
  ]);

  const handleGradeLevelChange = (gradeLevel) => {
    setGradeLevels((prevGradeLevels) =>
      prevGradeLevels.includes(gradeLevel)
        ? prevGradeLevels.filter((level) => level !== gradeLevel)
        : [...prevGradeLevels, gradeLevel]
    );
  };

  const handleSchoolChange = (school, field, value) => {
    if (school === "highSchool") {
      setHighSchoolDetails((prevDetails) => ({
        ...prevDetails,
        [field]: value,
      }));
    } else if (school === "middleSchool") {
      setMiddleSchoolDetails((prevDetails) => ({
        ...prevDetails,
        [field]: value,
      }));
    } else if (school === "elementarySchool") {
      setElementarySchoolDetails((prevDetails) => ({
        ...prevDetails,
        [field]: value,
      }));
    }
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  const fetchCourses = async (school) => {
    let details;
    if (school === "highSchool") {
      details = highSchoolDetails;
    } else if (school === "middleSchool") {
      details = middleSchoolDetails;
    } else if (school === "elementarySchool") {
      details = elementarySchoolDetails;
    }

    const { courseYear, catalogTerm, courseType } = details;

    // Add validation checks
    if (!courseYear) {
      toast.error("Please select a Course Catalog Year");
      return;
    }
    if (!catalogTerm) {
      toast.error("Please select a Course Catalog Term");
      return;
    }

    if (courseYear && catalogTerm && courseType) {
      setLoading(true);
      try {
        if (localStorage.token) {
          setAuthToken(localStorage.token);
        }
        const response = await axios.get(
          "https://api.llac.io/api/v1/config/course_catalog",
          {
            params: {
              charter_id: charter_id,
              school_year: courseYear,
              catalog_term: catalogTerm,
              course_type: courseType,
            },
            headers: {
              "x-functions-key":
                "EqYg_WkZwwovAVTKf77bco1UJjkzxmviAbJXhiXtxwEvAzFuWvAQ1A==",
            },
            withCredentials: false, // Disable credentials for external API CORS
          }
        );

        const fetchedCourses = response.data.data;

        const coursesFromCatalog = CourseCatalog.flatMap((item) => item).filter(
          (course) => course.LeloRegistrationProfile === courseid
        );

        const automaticallySelectedCourses = fetchedCourses.filter(
          (fetchedCourse) =>
            coursesFromCatalog.some(
              (catalogCourse) =>
                catalogCourse.course_name.includes(fetchedCourse.course_name) &&
                catalogCourse.course_type.includes(fetchedCourse.course_type) &&
                catalogCourse.school_year.includes(fetchedCourse.school_year) &&
                catalogCourse.catalog_term.includes(fetchedCourse.catalog_term)
            )
        );

        if (school === "highSchool") {
          setState({
            ...state,
            rightItems: automaticallySelectedCourses, // Update rightItems for high school
          });
        } else if (school === "middleSchool") {
          setState({
            ...state,
            rightItems1: automaticallySelectedCourses, // Update rightItems1 for middle school
          });
        } else if (school === "elementarySchool") {
          setState({
            ...state,
            rightItems2: automaticallySelectedCourses, // Update rightItems2 for elementary school
          });
        }


        if (school === "highSchool") {
          setHighSchoolDetails((prevDetails) => ({
            ...prevDetails,
            courses: fetchedCourses,
          }));
        } else if (school === "middleSchool") {
          setMiddleSchoolDetails((prevDetails) => ({
            ...prevDetails,
            courses: fetchedCourses,
          }));
        } else if (school === "elementarySchool") {
          setElementarySchoolDetails((prevDetails) => ({
            ...prevDetails,
            courses: fetchedCourses,
          }));
        }

        // Automatically select courses that are in the CourseCatalog
        setSelectedCourses((prevSelectedCourses) => [
          ...prevSelectedCourses,
          ...automaticallySelectedCourses.map((course) => ({
            ...course,
            gradeLevel: school,
          })),
        ]);

        setLoading(false);
      } catch (error) {
        console.error("Error fetching courses:", error);
        setLoading(false);
        ErrorLogger.logError(error.message);
      }
    }
  };

  const handleCheckboxChange = (course) => {
    setSelectedCourses((prevSelectedCourses) => {
      // Check if the course is already selected
      if (
        prevSelectedCourses.some(
          (selected) => selected.course_name === course.course_name
        )
      ) {
        // If it is, remove it from the selectedCourses array and add to unselectedCourses
        setUnselectedCourses((prevUnselected) => [...prevUnselected, course]);
        return prevSelectedCourses.filter(
          (selected) => selected.course_name !== course.course_name
        );
      } else {
        // If it isn't, add it to the selectedCourses array and remove from unselectedCourses
        setUnselectedCourses((prevUnselected) =>
          prevUnselected.filter(
            (unselected) => unselected.course_name !== course.course_name
          )
        );
        return [...prevSelectedCourses, course];
      }
    });
  };

  const handleSelectAll = (allCourses) => {
    setSelectedCourses(
      (prevSelectedCourses) =>
        prevSelectedCourses.length === allCourses.length
          ? [] // Deselect all if already all are selected
          : allCourses // Select all courses if not already selected
    );
  };

  const handleSubmit = async () => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }

      // Get all courses that were initially selected but are now unselected
      const allRightItems = [
        ...state.rightItems,
        ...state.rightItems1,
        ...state.rightItems2,
      ];

      const unselectedRightItems = allRightItems.filter(
        (course) =>
          !selectedCourses.some(
            (selected) => selected.course_name === course.course_name
          )
      );

      // Combine with existing unselectedCourses
      const allUnselectedCourses = [
        ...unselectedCourses,
        ...unselectedRightItems,
      ];

      // Prepare the payload conditionally
      const payload = {
        courses: selectedCourses,
        unselectedCourses: allUnselectedCourses,
        learningCenterName: name,
        siteId: siteIdString,
        LeloRegistrationProfile: courseid,
        permalink: permalink,
      };

      // Include high school details if totalCourses is present
      if (highSchoolDetails?.totalCourses) {
        payload.highSchoolDetails = { ...highSchoolDetails };
      }

      // Include middle school details if totalCourses is present
      if (middleSchoolDetails?.totalCourses) {
        payload.middleSchoolDetails = { ...middleSchoolDetails };
      }

      // Include elementary school details if totalCourses is present
      if (elementarySchoolDetails?.totalCourses) {
        payload.elementarySchoolDetails = { ...elementarySchoolDetails };
      }

      const response = await axios.put(`${appUrl}/api/courses/${id}`, payload);

      toast.success("Courses submitted successfully!");
      setLoading(false);
      navigate(-1);
    } catch (error) {
      console.error("Error submitting courses:", error);
      setLoading(false);
      toast.error("Failed to submit courses.");
      ErrorLogger.logError(error.message);
    }
  };

  const school_year = [
    ...new Set(CourseOptionCatalogID.map((item) => item.school_year)),
  ].sort((a, b) => b.localeCompare(a));
  const course_type = [
    ...new Set(CourseOptionCatalogID.map((item) => item.course_type)),
  ];
  const catalog_term = [
    ...new Set(CourseOptionCatalogID.map((item) => item.catalog_term)),
  ];

  const openModal = (type) => {
    let url =
      type === "confirmation"
        ? `/edit-confirmation/${charter_id}/${name}/${courseid}/${permalink}/${id}`
        : `/edit-email-confirmation/${charter_id}/${name}/${courseid}/${permalink}/${id}`;

    setModalUrl(url);
    setShowModal(true);
  };

  return (
    <AdminLayout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Edit Courses</title>
      </Helmet>
      <section id="interest-form-list-page" className="py-10 border">
        <div className="container">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              marginBottom: "20px",
            }}
          >
            <FaIcons.FaArrowLeft
              className="menu-icon"
              onClick={handleBackClick}
              style={{
                cursor: "pointer",
                position: "absolute",
                left: 0,
                color: "#537131",
              }}
            />
            <span
              onClick={handleBackClick}
              style={{
                position: "absolute",
                left: "20px",
                cursor: "pointer",
                fontSize: "18px",
                color: "#537131",
              }}
            >
              Go Back
            </span>
            <h1
              className="text-center top-title mb-6"
              style={{
                margin: "auto",
                padding: "10px",
              }}
            >
              Learning Center Options
            </h1>
          </div>
          <h2
            className="text-center top-title mb-6"
            style={{ fontSize: "25px", margin: "auto" }}
          >
            {charter} - {name}
          </h2>

          {/* Buttons */}
          <div className="form-group" style={{ display: "flex", gap: "10px" }}>
            <button
              className="btn btn-llac-dark-green"
              disabled={loading}
              onClick={() => openModal("confirmation")}
            >
              Confirmation Page Details
            </button>
            <button
              className="btn btn-llac-dark-green"
              disabled={loading}
              onClick={() => openModal("email")}
            >
              Email Notifications
            </button>
          </div>

          {/* Modal */}
          <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            dialogClassName="modal-90w"
            centered
          >
            <Modal.Header closeButton>
              {/* <Modal.Title>Edit Page</Modal.Title> */}
            </Modal.Header>
            <Modal.Body>
              <iframe
                src={modalUrl}
                width="100%"
                height="100%"
                style={{
                  border: "none",
                  overflow: "auto",
                }}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-llac-dark-green"
                onClick={() => setShowModal(false)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
          <div className="form-group mb-4">
            <label className="form-label fw-bold" style={{ fontSize: "22px" }}>
              <b>Course Offerings</b>
            </label>
            <label className="form-label fw-bold" style={{ fontSize: "18px" }}>
              <b>Provide the Grade Levels Offered</b>
            </label>
            <div
              className="form-check"
              style={{
                display: "grid",
                "grid-template-columns": "1em auto",
                gap: "0.5em",
              }}
            >
              <input
                type="checkbox"
                id="high-school"
                value="High School"
                checked={gradeLevels.includes("High School")}
                onChange={() => handleGradeLevelChange("High School")}
                className="form-check-input"
              />
              <label
                className="form-check-label"
                style={{ marginLeft: "10px" }}
                htmlFor="high-school"
              >
                High School
              </label>
            </div>
            <div
              className="form-check"
              style={{
                display: "grid",
                "grid-template-columns": "1em auto",
                gap: "0.5em",
              }}
            >
              <input
                type="checkbox"
                id="middle-school"
                value="Middle School"
                checked={gradeLevels.includes("Middle School")}
                onChange={() => handleGradeLevelChange("Middle School")}
                className="form-check-input"
              />
              <label
                className="form-check-label"
                style={{ marginLeft: "10px" }}
                htmlFor="middle-school"
              >
                Middle School
              </label>
            </div>
            <div
              className="form-check"
              style={{
                display: "grid",
                "grid-template-columns": "1em auto",
                gap: "0.5em",
              }}
            >
              <input
                type="checkbox"
                id="elementary-school"
                value="Elementary School"
                checked={gradeLevels.includes("Elementary School")}
                onChange={() => handleGradeLevelChange("Elementary School")}
                className="form-check-input"
              />
              <label
                className="form-check-label"
                style={{ marginLeft: "10px" }}
                htmlFor="elementary-school"
              >
                Elementary School
              </label>
            </div>
          </div>

          {gradeLevels.includes("High School") && (
            <div className="grade-level-details mb-4 p-3 border rounded">
              <h3 className="mb-3">High School</h3>
              <div className="form-group mb-3">
                <label className="form-label fw-bold">
                  <b>
                    Should NCAA notifications be included on the registration
                    form?
                  </b>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </label>
                <div className="form-check">
                  <input
                    type="radio"
                    id="ncaa-yes"
                    name="includeNCAA"
                    value="Yes"
                    checked={highSchoolDetails.includeNCAA === "Yes"}
                    onChange={(e) =>
                      handleSchoolChange(
                        "highSchool",
                        "includeNCAA",
                        e.target.value
                      )
                    }
                    className="form-check-input"
                  />
                  <label className="form-check-label" htmlFor="ncaa-yes">
                    YES - Include NCAA Notifications
                  </label>
                </div>
                <div className="form-check">
                  <input
                    type="radio"
                    id="ncaa-no"
                    name="includeNCAA"
                    value="No"
                    checked={highSchoolDetails.includeNCAA === "No"}
                    onChange={(e) =>
                      handleSchoolChange(
                        "highSchool",
                        "includeNCAA",
                        e.target.value
                      )
                    }
                    className="form-check-input"
                  />
                  <label className="form-check-label" htmlFor="ncaa-no">
                    NO - Exclude NCAA Notifications
                  </label>
                </div>
              </div>
              <div className="form-group mb-3">
                <label className="form-label fw-bold">
                  <b>
                    What is the maximum number of high school courses a student
                    can enroll in?
                  </b>
                </label>
                <select
                  value={highSchoolDetails.totalCourses}
                  onChange={(e) =>
                    handleSchoolChange(
                      "highSchool",
                      "totalCourses",
                      e.target.value
                    )
                  }
                  className="form-control"
                  style={{
                    width: "90px",
                    padding: "0.5rem",
                    marginLeft: "10px",
                  }}
                >
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                </select>
              </div>

              <div>
                <h3 className="mb-3">Course Catalog</h3>
              </div>
              <div className="form-group mb-3">
                <label className="form-label fw-bold">
                  <b>Select a Course Catalog Year</b>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </label>
                <select
                  className="form-control"
                  value={highSchoolDetails.courseYear}
                  onChange={(e) =>
                    handleSchoolChange(
                      "highSchool",
                      "courseYear",
                      e.target.value
                    )
                  }
                >
                  <option value="">Course Catalog Year</option>
                  {school_year.map((year, index) => (
                    <option key={index} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group mb-3">
                <label className="form-label fw-bold">
                  <b>Select a Course Catalog Term</b>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </label>
                <select
                  className="form-control"
                  value={highSchoolDetails.catalogTerm}
                  onChange={(e) =>
                    handleSchoolChange(
                      "highSchool",
                      "catalogTerm",
                      e.target.value
                    )
                  }
                >
                  <option value="">Course Catalog Term</option>
                  {catalog_term.map((term, index) => (
                    <option key={index} value={term}>
                      {term}
                    </option>
                  ))}
                </select>
              </div>

              {/* use jquery code needed */}

              <div className="form-group">
                <button
                  className="btn btn-llac-dark-green"
                  onClick={() => fetchCourses("highSchool")}
                  disabled={loading}
                >
                  {loading ? "Fetching..." : "View Courses"}
                </button>
              </div>
              <div className="courses-list mt-3">
                {highSchoolDetails.courses.length > 0 && (
                  <>
                    <h4 className="fw-bold"> High School Courses:</h4>
                    <div className="card-container">
                      <div className="box-container">
                        <h3>Courses Available</h3>
                        <input
                          type="text"
                          placeholder="Search..."
                          value={state.leftSearch}
                          onChange={handleLeftSearchChange}
                          className="search-box"
                        />
                        <ul className="list">
                          {paginate(
                            filterItems(
                              highSchoolDetails.courses,
                              state.leftSearch
                            ),
                            state.leftPage
                          ).map((course, index) => (
                            <li key={index} className="list-item">
                              <input
                                type="checkbox"
                                id={`high-school-course-${index}`}
                                value={course.course_name}
                                checked={selectedCourses.some(
                                  (selected) =>
                                    selected.course_name === course.course_name
                                )}
                                onChange={() => handleCheckboxChange(course)}
                              />
                              <label
                                htmlFor={`high-school-left-course-${index}`}
                                style={{ marginLeft: "10px" }}
                              >
                                {course.course_name}
                              </label>
                            </li>
                          ))}
                        </ul>
                        {renderPagination(
                          filterItems(
                            highSchoolDetails.courses,
                            state.leftSearch
                          ),
                          state.leftPage,
                          (newPage) => setState({ ...state, leftPage: newPage })
                        )}
                      </div>

                      <div className="button-container">
                        <button
                          onClick={() =>
                            moveItems(
                              highSchoolDetails.courses,
                              state.rightItems,
                              (newItems) =>
                                setState((prevState) => ({
                                  ...prevState,
                                  leftItems: newItems,
                                })),
                              (newItems) =>
                                setState((prevState) => ({
                                  ...prevState,
                                  rightItems: newItems,
                                })),
                              false // Adding courses (left to right)
                            )
                          }
                          className="move-button"
                        >
                          &gt;&gt;
                        </button>
                        <br />
                        <br />
                        <button
                          onClick={() =>
                            moveItems(
                              state.rightItems,
                              highSchoolDetails.courses,
                              (newItems) =>
                                setState((prevState) => ({
                                  ...prevState,
                                  rightItems: newItems,
                                })),
                              (newItems) =>
                                setState((prevState) => ({
                                  ...prevState,
                                  leftItems: newItems,
                                })),
                              true // Removing courses (right to left)
                            )
                          }
                          className="move-button"
                        >
                          &lt;&lt;
                        </button>
                      </div>

                      <div className="box-container">
                        <h3>Courses Selected</h3>
                        <input
                          type="text"
                          placeholder="Search..."
                          value={state.rightSearch}
                          onChange={handleRightSearchChange}
                          className="search-box"
                        />
                        <b>
                          Please ensure you select 'Select All' below before
                          submitting.
                        </b>
                        <ul className="list">
                          {paginate(
                            filterItems(state.rightItems, state.rightSearch),
                            state.rightPage
                          ).map((course, index) => (
                            <li key={index} className="list-item">
                              <input
                                type="checkbox"
                                id={`high-school-course-${index}`}
                                value={course.course_name}
                                checked={selectedCourses.some(
                                  (selected) =>
                                    selected.course_name === course.course_name
                                )}
                                onChange={() => handleCheckboxChange(course)}
                              />
                              <label
                                htmlFor={`high-school-right-course-${index}`}
                                style={{ marginLeft: "10px" }}
                              >
                                {course.course_name}
                              </label>
                            </li>
                          ))}
                        </ul>
                        {renderPagination(
                          filterItems(state.rightItems, state.rightSearch),
                          state.rightPage,
                          (newPage) =>
                            setState({ ...state, rightPage: newPage })
                        )}
                      </div>
                    </div>

                    {/*we are change */}
                  </>
                )}
              </div>
            </div>
          )}

          {gradeLevels.includes("Middle School") && (
            <div className="grade-level-details mb-4 p-3 border rounded">
              <h3 className="mb-3">Middle School</h3>
              <div className="form-group mb-3">
                <label className="form-label fw-bold">
                  <b>
                    What is the maximum number of middle school courses a
                    student can enroll in?
                  </b>
                </label>
                <select
                  value={middleSchoolDetails.totalCourses}
                  onChange={(e) =>
                    handleSchoolChange(
                      "middleSchool",
                      "totalCourses",
                      e.target.value
                    )
                  }
                  className="form-control"
                  style={{
                    width: "90px",
                    padding: "0.5rem",
                    marginLeft: "10px",
                  }}
                >
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                </select>
              </div>
              {/* <div className="form-group mb-3">
                <label className="form-label fw-bold">
                  <b>Middle School Course Type</b>
                </label>
                <input
                  className="form-control"
                  type="text"
                  value={middleSchoolDetails.courseType}
                  style={{
                    width: "150px",
                    padding: "0.5rem",
                    marginLeft: "10px",
                  }}
                />
              </div> */}
              <h3 className="mb-3">Course Catalog</h3>
              <div className="form-group mb-3">
                <label className="form-label fw-bold">
                  <b>Select a Course Catalog Year</b>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </label>
                <select
                  className="form-control"
                  value={middleSchoolDetails.courseYear}
                  onChange={(e) =>
                    handleSchoolChange(
                      "middleSchool",
                      "courseYear",
                      e.target.value
                    )
                  }
                >
                  <option value="">Course Catalog Year</option>
                  {school_year.map((year, index) => (
                    <option key={index} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group mb-3">
                <label className="form-label fw-bold">
                  <b>Select a Course Catalog Term</b>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </label>
                <select
                  className="form-control"
                  value={middleSchoolDetails.catalogTerm}
                  onChange={(e) =>
                    handleSchoolChange(
                      "middleSchool",
                      "catalogTerm",
                      e.target.value
                    )
                  }
                >
                  <option value="">Course Catalog Term</option>
                  {catalog_term.map((term, index) => (
                    <option key={index} value={term}>
                      {term}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <button
                  className="btn btn-llac-dark-green"
                  onClick={() => fetchCourses("middleSchool")}
                  disabled={loading}
                >
                  {loading ? "Fetching..." : "View Courses"}
                </button>
              </div>
              <div className="courses-list mt-3">
                {middleSchoolDetails.courses.length > 0 && (
                  <>
                    <h4 className="fw-bold">Middle School Courses:</h4>

                    {/* {middleSchoolDetails.courses.map((course, index) => (
                      <div>
                        <input
                          type="checkbox"
                          id={`course-${course.course_name}`}
                          value={course.course_name}
                          checked={selectedCourses.some(
                            (selected) =>
                              selected.course_name === course.course_name
                          )}
                          onChange={() => handleCheckboxChange(course)}
                        />
                        <label
                          htmlFor={`course-${course.course_name}`}
                          style={{ marginLeft: "10px" }}
                        >
                          {course.course_name}
                        </label>
                      </div>
                    ))} */}
                    {/** */}
                    <div className="card-container">
                      <div className="box-container">
                        <h3>Courses Available</h3>
                        <input
                          type="text"
                          placeholder="Search..."
                          value={state.leftSearch1}
                          onChange={handleLeftSearchChange1}
                          className="search-box"
                        />
                        <ul className="list">
                          {paginate(
                            filterItems(
                              middleSchoolDetails.courses,
                              state.leftSearch1
                            ),
                            state.leftPage1
                          ).map((course, index) => (
                            <li key={index} className="list-item">
                              <input
                                type="checkbox"
                                id={`middleschool-left-course-${index}`}
                                value={course.course_name}
                                checked={selectedCourses.some(
                                  (selected) =>
                                    selected.course_name === course.course_name
                                )}
                                onChange={() => handleCheckboxChange(course)}
                              />
                              <label
                                htmlFor={`middleschool-left-course-${index}`}
                                style={{ marginLeft: "10px" }}
                              >
                                {course.course_name}
                              </label>
                            </li>
                          ))}
                        </ul>
                        {renderPagination(
                          filterItems(
                            middleSchoolDetails.courses,
                            state.leftSearch1
                          ),
                          state.leftPage1,
                          (newPage) =>
                            setState({ ...state, leftPage1: newPage }) // Updating leftPage1 in state
                        )}
                      </div>

                      <div className="button-container">
                        <button
                          onClick={() =>
                            moveItems(
                              middleSchoolDetails.courses,
                              state.rightItems1,
                              (newItems) =>
                                setState((prevState) => ({
                                  ...prevState,
                                  leftItems: newItems,
                                })),
                              (newItems) =>
                                setState((prevState) => ({
                                  ...prevState,
                                  rightItems1: newItems,
                                })),
                              false // Adding courses (left to right)
                            )
                          }
                          className="move-button"
                        >
                          &gt;&gt;
                        </button>
                        <br />
                        <br />
                        <button
                          onClick={() =>
                            moveItems(
                              state.rightItems1,
                              middleSchoolDetails.courses,
                              (newItems) =>
                                setState((prevState) => ({
                                  ...prevState,
                                  rightItems1: newItems,
                                })),
                              (newItems) =>
                                setState((prevState) => ({
                                  ...prevState,
                                  leftItems: newItems,
                                })),
                              true // Removing courses (right to left)
                            )
                          }
                          className="move-button"
                        >
                          &lt;&lt;
                        </button>
                      </div>

                      <div className="box-container">
                        <h3>Courses Selected</h3>
                        <input
                          type="text"
                          placeholder="Search..."
                          value={state.rightSearch1}
                          onChange={handleRightSearchChange1}
                          className="search-box"
                        />
                        <b>
                          Please ensure you select 'Select All' below before
                          submitting.
                        </b>
                        <ul className="list">
                          {paginate(
                            filterItems(state.rightItems1, state.rightSearch1),
                            state.rightPage1
                          ).map((course, index) => (
                            <li key={index} className="list-item">
                              <input
                                type="checkbox"
                                id={`middleschool-right-course-${index}`}
                                value={course.course_name}
                                onChange={() => handleCheckboxChange(course)}
                                checked={selectedCourses.some(
                                  (selected) =>
                                    selected.course_name === course.course_name
                                )}
                              />
                              <label
                                htmlFor={`middleschool-right-course-${index}`}
                                style={{ marginLeft: "10px" }}
                              >
                                {course.course_name}
                              </label>
                            </li>
                          ))}
                        </ul>
                        {renderPagination(
                          filterItems(state.rightItems1, state.rightSearch1),
                          state.rightPage1,
                          (newPage) =>
                            setState({ ...state, rightPage1: newPage }) // Updating rightPage1 in state
                        )}
                      </div>
                    </div>
                    {/** */}
                  </>
                )}
              </div>
            </div>
          )}

          {gradeLevels.includes("Elementary School") && (
            <div className="grade-level-details mb-4 p-3 border rounded">
              <h3 className="mb-3">Elementary School</h3>
              <div className="form-group mb-3">
                <label className="form-label fw-bold">
                  <b>Maximum Number of Elementary School Courses</b>
                </label>
                <select
                  value={elementarySchoolDetails.totalCourses}
                  onChange={(e) =>
                    handleSchoolChange(
                      "elementarySchool",
                      "totalCourses",
                      e.target.value
                    )
                  }
                  className="form-control"
                  style={{
                    width: "90px",
                    padding: "0.5rem",
                    marginLeft: "10px",
                  }}
                >
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                </select>
              </div>
              {/* <div className="form-group mb-3">
                <label className="form-label fw-bold">
                  <b>Elementary School Course Type</b>
                </label>
                <input
                  className="form-control"
                  type="text"
                  value={elementarySchoolDetails.courseType}
                  style={{
                    width: "180px",
                    padding: "0.5rem",
                    marginLeft: "10px",
                  }}
                />
              </div> */}
              <h3 className="mb-3">Course Catalog</h3>
              <div className="form-group mb-3">
                <label className="form-label fw-bold">
                  <b>Select a Course Catalog Year</b>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </label>
                <select
                  className="form-control"
                  value={elementarySchoolDetails.courseYear}
                  onChange={(e) =>
                    handleSchoolChange(
                      "elementarySchool",
                      "courseYear",
                      e.target.value
                    )
                  }
                >
                  <option value="">Course Catalog Year</option>
                  {school_year.map((year, index) => (
                    <option key={index} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group mb-3">
                <label className="form-label fw-bold">
                  <b>Select a Course Catalog Term</b>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </label>
                <select
                  className="form-control"
                  value={elementarySchoolDetails.catalogTerm}
                  onChange={(e) =>
                    handleSchoolChange(
                      "elementarySchool",
                      "catalogTerm",
                      e.target.value
                    )
                  }
                >
                  <option value="">Course Catalog Term</option>
                  {catalog_term.map((term, index) => (
                    <option key={index} value={term}>
                      {term}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <button
                  className="btn btn-llac-dark-green"
                  onClick={() => fetchCourses("elementarySchool")}
                  disabled={loading}
                >
                  {loading ? "Fetching..." : "View Courses"}
                </button>
              </div>
              <div className="courses-list mt-3">
                {elementarySchoolDetails.courses.length > 0 && (
                  <>
                    <h4 className="fw-bold"> Elementary School Courses:</h4>
                    <div className="card-container">
                      <div className="box-container">
                        <h3>Courses Available</h3>
                        <input
                          type="text"
                          placeholder="Search..."
                          value={state.leftSearch2}
                          onChange={handleLeftSearchChange2}
                          className="search-box"
                        />
                        <ul className="list">
                          {paginate(
                            filterItems(
                              elementarySchoolDetails.courses,
                              state.leftSearch2
                            ),
                            state.leftPage2
                          ).map((course, index) => (
                            <li key={index} className="list-item">
                              <input
                                type="checkbox"
                                id={`elementary-school-course-${index}`}
                                value={course.course_name}
                                checked={selectedCourses.some(
                                  (selected) =>
                                    selected.course_name === course.course_name
                                )}
                                onChange={() => handleCheckboxChange(course)}
                              />
                              <label
                                htmlFor={`elementary-left-course-${index}`}
                                style={{ marginLeft: "10px" }}
                              >
                                {course.course_name}
                              </label>
                            </li>
                          ))}
                        </ul>
                        {renderPagination(
                          filterItems(
                            elementarySchoolDetails.courses,
                            state.leftSearch2
                          ),
                          state.leftPage2,
                          (newPage) =>
                            setState({ ...state, leftPage2: newPage })
                        )}
                      </div>

                      <div className="button-container">
                        <button
                          onClick={() =>
                            moveItems(
                              elementarySchoolDetails.courses,
                              state.rightItems2,
                              (newItems) =>
                                setState((prevState) => ({
                                  ...prevState,
                                  leftItems: newItems,
                                })),
                              (newItems) =>
                                setState((prevState) => ({
                                  ...prevState,
                                  rightItems2: newItems,
                                })),
                              false // Adding courses (left to right)
                            )
                          }
                          className="move-button"
                        >
                          &gt;&gt;
                        </button>
                        <br />
                        <br />
                        <button
                          onClick={() =>
                            moveItems(
                              state.rightItems2,
                              elementarySchoolDetails.courses,
                              (newItems) =>
                                setState((prevState) => ({
                                  ...prevState,
                                  rightItems2: newItems,
                                })),
                              (newItems) =>
                                setState((prevState) => ({
                                  ...prevState,
                                  leftItems: newItems,
                                })),
                              true // Removing courses (right to left)
                            )
                          }
                          className="move-button"
                        >
                          &lt;&lt;
                        </button>
                      </div>

                      <div className="box-container">
                        <h3>Courses Selected</h3>
                        <input
                          type="text"
                          placeholder="Search..."
                          value={state.rightSearch2}
                          onChange={handleRightSearchChange2}
                          className="search-box"
                        />
                        <b>
                          Please ensure you select 'Select All' below before
                          submitting.
                        </b>
                        <ul className="list">
                          {paginate(
                            filterItems(state.rightItems2, state.rightSearch2),
                            state.rightPage2
                          ).map((course, index) => (
                            <li key={index} className="list-item">
                              <input
                                type="checkbox"
                                id={`elementary-school-course-${index}`}
                                value={course.course_name}
                                checked={selectedCourses.some(
                                  (selected) =>
                                    selected.course_name === course.course_name
                                )}
                                onChange={() => handleCheckboxChange(course)}
                              />
                              <label
                                htmlFor={`elementary-right-course-${index}`}
                                style={{ marginLeft: "10px" }}
                              >
                                {course.course_name}
                              </label>
                            </li>
                          ))}
                        </ul>
                        {renderPagination(
                          filterItems(state.rightItems2, state.rightSearch2),
                          state.rightPage2,
                          (newPage) =>
                            setState({ ...state, rightPage2: newPage })
                        )}
                      </div>
                    </div>

                    {/*we are change */}
                  </>
                )}
              </div>
            </div>
          )}

          {/* Submit Button */}
          <div className="form-group">
            <button
              className="btn btn-llac-dark-green"
              onClick={handleSubmit} // Define your submit logic here
              disabled={loading} // You can disable based on loading state if needed
            >
              Submit
            </button>
          </div>
        </div>
      </section>
    </AdminLayout>
  );
};

export default EditFinalCourse;
